// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EWcCz5_T44u0LJVzL3O_ {
  /* Override default styling for mystery theme */
  --jp-currency-line-height: 1;
  row-gap: 3px;
  /* Mystery-specific level styling */
  /* Panel icon styling */
}
.EWcCz5_T44u0LJVzL3O_ div[data-type='levelsContainer'] {
  align-self: start;
}
.EWcCz5_T44u0LJVzL3O_ div[data-level='grand'] {
  --jp-level-padding-top: 19px;
  --jp-currency-margin-left: 8px;
}
.EWcCz5_T44u0LJVzL3O_ div[data-level='major'] {
  --jp-level-padding-top: 19px;
  --jp-currency-margin-left: 6px;
}
.EWcCz5_T44u0LJVzL3O_ div[data-level='minor'],
.EWcCz5_T44u0LJVzL3O_ div[data-level='mini'] {
  --jp-level-padding-top: 11px;
  --jp-currency-margin-left: 3.5px;
}
.EWcCz5_T44u0LJVzL3O_ div[data-level='mini'] {
  margin-right: 10px;
}
.EWcCz5_T44u0LJVzL3O_ div[data-type='panelIcon'] {
  max-width: 70px;
  align-self: end;
}
@media (max-width: 1025px) {
  .EWcCz5_T44u0LJVzL3O_ {
    /* Level Font Size */
    --jp-grand-font-size: 37px;
    --jp-major-font-size: 32px;
    --jp-minor-font-size: 19px;
    --jp-mini-font-size: 19px;
  }
  .EWcCz5_T44u0LJVzL3O_ div[data-type='panelIcon'] {
    max-width: 64px;
  }
  .EWcCz5_T44u0LJVzL3O_ div[data-level='grand'] span[data-currency-level='grand'] {
    --jp-currency-margin-left: 6.5px;
  }
  .EWcCz5_T44u0LJVzL3O_ div[data-level='minor'] span[data-currency-level='minor'],
  .EWcCz5_T44u0LJVzL3O_ div[data-level='mini'] span[data-currency-level='mini'] {
    --jp-currency-margin-left: 3.5px;
  }
}
@media (orientation: portrait) {
  .EWcCz5_T44u0LJVzL3O_ {
    margin-bottom: 18px;
  }
}
@media (orientation: landscape) {
  .EWcCz5_T44u0LJVzL3O_ {
    margin-bottom: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/jackpots/components/variants/Mystery/Mystery.module.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,4BAA4B;EAC5B,YAAY;EACZ,mCAAmC;EACnC,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;;EAEE,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE;IACE,oBAAoB;IACpB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,gCAAgC;EAClC;EACA;;IAEE,gCAAgC;EAClC;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".mysteryTheme {\n  /* Override default styling for mystery theme */\n  --jp-currency-line-height: 1;\n  row-gap: 3px;\n  /* Mystery-specific level styling */\n  /* Panel icon styling */\n}\n.mysteryTheme div[data-type='levelsContainer'] {\n  align-self: start;\n}\n.mysteryTheme div[data-level='grand'] {\n  --jp-level-padding-top: 19px;\n  --jp-currency-margin-left: 8px;\n}\n.mysteryTheme div[data-level='major'] {\n  --jp-level-padding-top: 19px;\n  --jp-currency-margin-left: 6px;\n}\n.mysteryTheme div[data-level='minor'],\n.mysteryTheme div[data-level='mini'] {\n  --jp-level-padding-top: 11px;\n  --jp-currency-margin-left: 3.5px;\n}\n.mysteryTheme div[data-level='mini'] {\n  margin-right: 10px;\n}\n.mysteryTheme div[data-type='panelIcon'] {\n  max-width: 70px;\n  align-self: end;\n}\n@media (max-width: 1025px) {\n  .mysteryTheme {\n    /* Level Font Size */\n    --jp-grand-font-size: 37px;\n    --jp-major-font-size: 32px;\n    --jp-minor-font-size: 19px;\n    --jp-mini-font-size: 19px;\n  }\n  .mysteryTheme div[data-type='panelIcon'] {\n    max-width: 64px;\n  }\n  .mysteryTheme div[data-level='grand'] span[data-currency-level='grand'] {\n    --jp-currency-margin-left: 6.5px;\n  }\n  .mysteryTheme div[data-level='minor'] span[data-currency-level='minor'],\n  .mysteryTheme div[data-level='mini'] span[data-currency-level='mini'] {\n    --jp-currency-margin-left: 3.5px;\n  }\n}\n@media (orientation: portrait) {\n  .mysteryTheme {\n    margin-bottom: 18px;\n  }\n}\n@media (orientation: landscape) {\n  .mysteryTheme {\n    margin-bottom: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mysteryTheme": `EWcCz5_T44u0LJVzL3O_`
};
export default ___CSS_LOADER_EXPORT___;
